import React, { useState } from "react";

const FAQ = () => {
  const [openAccordion, setOpenAccordion] = useState(null);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? null : index);
  };

  return (
    <section className="py-3 py-md-5">
      <div className="container-fluid">
        <div className="row gy-5 gy-lg-0 align-items-lg-center">
          <div className="col-12 col-lg-6">
            <img
              className="img-fluid rounded mb-6"
              loading="lazy"
              src="https://storage.googleapis.com/kegow-public/kegow-wallet-users.jpeg"
              alt="Women using Kegow wallet"
            />
          </div>
          <div className="col-12 col-lg-6">
            <div className="row justify-content-xl-end">
              <div className="col-12 col-xl-11">
                <h2 className="mb-3 text-primary text-center fw-bolder text-nowrap">
                  Frequently Asked Questions
                </h2>
                <p className="text-center mb-5">How can we help you?</p>
                <p className="text-secondary mb-5">
                  We hope you find an answer to your question(s). If you need
                  further assistance, do not hesitate to contact us via email
                  for support.
                </p>
                <div className="accordion accordion-flush" id="accordionExample">
                  <div className="accordion-group">
                    <h3 className="accordion-heading fw-bolder">
                      Account Opening
                    </h3>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingOne">
                        <button
                          className={`accordion-button text-secondary ${
                            openAccordion === 0 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseOne"
                          aria-expanded="true"
                          aria-controls="collapseOne"
                          onClick={() => toggleAccordion(0)}
                        >
                          How do I sign up for an account?
                        </button>
                      </h2>
                      <div
                        id="collapseOne"
                        className={`accordion-collapse collapse ${
                          openAccordion === 0 ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          To sign up for an account, click on the "Sign Up"
                          button on the homepage and follow the prompts to
                          create your account.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFive">
                        <button
                          className={`accordion-button text-secondary ${
                            openAccordion === 4 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFive"
                          aria-expanded="false"
                          aria-controls="collapseFive"
                          onClick={() => toggleAccordion(4)}
                        >
                          How do I close my account?
                        </button>
                      </h2>
                      <div
                        id="collapseFive"
                        className={`accordion-collapse collapse ${
                          openAccordion === 4 ? "show" : ""
                        }`}
                        aria-labelledby="headingFive"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          To close your account, please contact our customer
                          support team for assistance. They will guide you
                          through the account closure process.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-group">
                    <h3 className="accordion-heading fw-bolder mt-6">
                      Transactions
                    </h3>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingTwo">
                        <button
                          className={`accordion-button text-secondary ${
                            openAccordion === 1 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseTwo"
                          aria-expanded="false"
                          aria-controls="collapseTwo"
                          onClick={() => toggleAccordion(1)}
                        >
                          How do I deposit money into my account?
                        </button>
                      </h2>
                      <div
                        id="collapseTwo"
                        className={`accordion-collapse collapse ${
                          openAccordion === 1 ? "show" : ""
                        }`}
                        aria-labelledby="headingTwo"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          You can deposit money into your account by
                          transferring funds to your wallet — either via bank
                          transfer or another Kegow wallet.
                        </div>
                      </div>
                    </div>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingThree">
                        <button
                          className={`accordion-button text-secondary ${
                            openAccordion === 2 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseThree"
                          aria-expanded="false"
                          aria-controls="collapseThree"
                          onClick={() => toggleAccordion(2)}
                        >
                          How do I transfer money to another account?
                        </button>
                      </h2>
                      <div
                        id="collapseThree"
                        className={`accordion-collapse collapse ${
                          openAccordion === 2 ? "show" : ""
                        }`}
                        aria-labelledby="headingThree"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          You can transfer money to another account by using the
                          transfer to bank or transfer to wallet option. Enter
                          the recipient's account details and the amount you
                          wish to transfer.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="accordion-group">
                    <h3 className="accordion-heading fw-bolder mt-6">KYC</h3>
                    <div className="accordion-item">
                      <h2 className="accordion-header" id="headingFour">
                        <button
                          className={`accordion-button text-secondary ${
                            openAccordion === 3 ? "" : "collapsed"
                          }`}
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target="#collapseFour"
                          aria-expanded="false"
                          aria-controls="collapseFour"
                          onClick={() => toggleAccordion(3)}
                        >
                          How do I update my personal information?
                        </button>
                      </h2>
                      <div
                        id="collapseFour"
                        className={`accordion-collapse collapse ${
                          openAccordion === 3 ? "show" : ""
                        }`}
                        aria-labelledby="headingFour"
                        data-bs-parent="#accordionExample"
                      >
                        <div className="accordion-body">
                          You can update your personal information by logging in
                          to your account and navigating to the KYC section,
                          under settings. Here, you can update your contact
                          details, address, and other personal information.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
